import Content from './Content';

const Table = ({style}) => (
    <table className="mobile-titles" style={style}>
        <Content />
    </table>
);

export default Table;
